import { ArrowDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

/**
 * A conversation's way back to its newest message once you've scrolled up to read: a round button floating
 * over the bottom middle of the thread (the chat, a task's Comments and Agent tabs; SF-T-222). Place it in a
 * `relative` box round the scrolling one, or `bottom-full` over a pinned box beneath, and show it only while
 * the newest isn't in view (useFollowScroll, useScrollEnd).
 */
export function JumpToLatestButton({ onClick, className }: { onClick: () => void; className?: string }) {
  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className={cn('absolute bottom-3 left-1/2 z-10 -translate-x-1/2 rounded-full shadow-md max-md:min-h-11', className)}
      onClick={onClick}
    >
      <ArrowDown aria-hidden />
      Jump to latest
    </Button>
  );
}
